var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomelyMini(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 489,
    height: 489,
    viewBox: "0 0 489 489",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_338",
    "data-name": "Rectangle 338",
    width: 262.904,
    height: 276.133,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 489,
    height: 489
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_1",
    "data-name": "Artboard \\u2013 1",
    clipPath: "url(#clip-Artboard_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_457",
    "data-name": "Group 457",
    transform: "translate(113 106)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_429",
    "data-name": "Group 429",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M219.587,124.392V29.862H9.787V166.5H22.779a19.731,19.731,0,0,1,19.7,19.711v26.734h166V201.764a27.3,27.3,0,0,1-7.717-42.949,23.049,23.049,0,0,1,18.815-34.423M84.833,188.038a5.117,5.117,0,0,1-5.126,5.111H59.613a5.087,5.087,0,0,1-5.114-5.111V160.246a5.1,5.1,0,0,1,5.114-5.132H79.707a5.132,5.132,0,0,1,5.126,5.132Zm0-52.725a5.117,5.117,0,0,1-5.126,5.11H59.613a5.087,5.087,0,0,1-5.114-5.11V107.521a5.1,5.1,0,0,1,5.114-5.132H79.707a5.132,5.132,0,0,1,5.126,5.132Zm0-52.725a5.117,5.117,0,0,1-5.126,5.11H59.613a5.087,5.087,0,0,1-5.114-5.11V54.8a5.1,5.1,0,0,1,5.114-5.132H79.707A5.132,5.132,0,0,1,84.833,54.8Zm45.021,52.725a5.117,5.117,0,0,1-5.126,5.11H104.634a5.087,5.087,0,0,1-5.114-5.11V107.521a5.1,5.1,0,0,1,5.114-5.132h20.093a5.132,5.132,0,0,1,5.126,5.132Zm45.021,52.725a5.117,5.117,0,0,1-5.126,5.111H149.655a5.087,5.087,0,0,1-5.114-5.111V160.246a5.1,5.1,0,0,1,5.114-5.132h20.093a5.132,5.132,0,0,1,5.126,5.132Zm0-52.725a5.117,5.117,0,0,1-5.126,5.11H149.655a5.087,5.087,0,0,1-5.114-5.11V107.521a5.1,5.1,0,0,1,5.114-5.132h20.093a5.132,5.132,0,0,1,5.126,5.132Zm0-52.725a5.117,5.117,0,0,1-5.126,5.11H149.655a5.087,5.087,0,0,1-5.114-5.11V54.8a5.1,5.1,0,0,1,5.114-5.132h20.093a5.132,5.132,0,0,1,5.126,5.132Z",
    transform: "translate(20.655 63.023)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M88.432,85.827v9.011H75.558V85.827a27.267,27.267,0,0,0,5.222.734c.4.022.806.031,1.21.031a27.3,27.3,0,0,0,6.442-.765",
    transform: "translate(159.461 181.134)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M114.7,3.257a23.162,23.162,0,0,1,23.686,0l61.531,36.61,44.47,26.461c8.078,4.806,4.669,17.2-4.728,17.2H13.434c-9.4,0-12.806-12.392-4.731-17.2l44.47-26.461Z",
    transform: "translate(8.797 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M57.263,89.516v26.9H0v-26.9A13.828,13.828,0,0,1,13.829,75.681H43.434A13.828,13.828,0,0,1,57.263,89.516",
    transform: "translate(0 159.721)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M113.63,86.65a21.427,21.427,0,0,1-9.135,17.562,21.188,21.188,0,0,1-2.939,1.733,20.429,20.429,0,0,1-2.936,1.176,21.479,21.479,0,0,1-6.442.983c-.411,0-.815-.016-1.213-.037a20.959,20.959,0,0,1-8.159-2.115,20.308,20.308,0,0,1-2.936-1.739,21.442,21.442,0,0,1-4.106-31.363,22.947,22.947,0,0,0,15.2,6.862c.4.022.809.028,1.213.028a22.966,22.966,0,0,0,16.423-6.89,21.326,21.326,0,0,1,5.03,13.8",
    transform: "translate(149.274 153.745)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M106.455,79.3a17.018,17.018,0,0,1-1.7,7.456,15.979,15.979,0,0,1-1.505,2.532,15.625,15.625,0,0,1-1.91,2.24,17.1,17.1,0,0,1-12.059,4.952c-.411,0-.815-.016-1.21-.044A17.082,17.082,0,0,1,77.223,91.53a16.091,16.091,0,0,1-1.916-2.246,15.87,15.87,0,0,1-1.5-2.526A17.167,17.167,0,0,1,88.066,62.177c.4-.031.8-.044,1.21-.044A17.174,17.174,0,0,1,106.455,79.3",
    transform: "translate(152.176 131.129)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomelyMini);
export default __webpack_public_path__ + "static/media/HomelyMini.6c7270ad8e7f58bc0247a111a61debd4.svg";
export { ForwardRef as ReactComponent };